import { TextCodes } from '@api/types/translation/TextCodes';
import { Title, customerFields, dealerFields, productFields } from '@components';
import { Divider, Grid, Skeleton } from '@mui/material';
import { t } from '@translations';

export const WarrantyDetailsLoadingSkeleton = () => {
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Title noDot variant='h3'>
            {t(TextCodes.Warranty.Block.Dealer)}
          </Title>
          <Grid container spacing={{ xs: 0, sm: 2 }}>
            <Grid item xs={12} lg={6}>
              {dealerFields().map((field) => (
                <Skeleton key={field.name} variant='text' width='100%' height={60} />
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Title noDot variant='h3'>
            {t(TextCodes.Warranty.Block.Customer)}
          </Title>
          <Grid container spacing={{ xs: 0, sm: 2 }}>
            <Grid item xs={12} lg={6}>
              {customerFields().map((field) => (
                <Skeleton key={field.name} variant='text' width='100%' height={60} />
              ))}
            </Grid>
          </Grid>
          <Skeleton variant='text' width={180} height={60} />
          <Skeleton variant='text' width={180} height={60} />
        </Grid>
      </Grid>
      <Divider sx={{ my: 4 }} />
      <Title noDot variant='h3'>
        {t(TextCodes.Warranty.Block.ProductInformation)}
      </Title>
      <Grid container spacing={{ xs: 0, sm: 2 }}>
        {productFields()?.map((columnFields, columnIndex) => (
          <Grid item xs={12} sm={6} key={columnIndex}>
            {columnFields.map((field, rowIndex) => {
              if (Array.isArray(field)) {
                return (
                  <Grid container key={rowIndex} spacing={{ xs: 0, lg: 2 }}>
                    {field.map((subField) => (
                      <Grid item xs={12} lg={6} key={subField.name}>
                        <Skeleton key={subField.name} variant='text' width='100%' height={60} />
                      </Grid>
                    ))}
                  </Grid>
                );
              } else {
                return field?.type === 'file' ? (
                  <Skeleton key={field.name} variant='text' width={100} height={60} />
                ) : (
                  <Skeleton key={field.name} variant='text' width='100%' height={60} />
                );
              }
            })}
          </Grid>
        ))}
      </Grid>
      <Divider sx={{ my: 4 }} />
      <Title noDot variant='h3'>
        {t(TextCodes.Warranty.Block.IssueDescription)}
      </Title>

      <Grid container spacing={{ xs: 0, md: 2 }}>
        <Grid item xs={12} md={6}>
          <Skeleton
            variant='rounded'
            width='100%'
            height={180}
            sx={{
              mt: 2,
              mb: {
                xs: 1,
                md: 0,
              },
            }}
          />
          <Grid container spacing={{ xs: 0, md: 2 }}>
            <Grid item xs={12} md={6}>
              <Skeleton variant='text' width='100%' height={60} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton variant='text' width='100%' height={60} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Skeleton
            variant='rounded'
            width='100%'
            height={180}
            sx={{
              mt: 2,
            }}
          />
          <Skeleton
            variant='rounded'
            width='100%'
            height={180}
            sx={{
              mt: {
                xs: 3,
                md: 2,
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
